import { Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { AuthGuard, AuthRedirectService, AuthService, SemanticPathService } from '@spartacus/core'
import { CookieService } from 'ngx-cookie-service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { securedPagesConfig } from '../eb-auth.config'
import { EbAuthService } from '../services/eb-auth.service'

/**
 * Checks if there is currently logged in user.
 * Use to protect pages dedicated only for logged in users.
 */
@Injectable({
  providedIn: 'root'
})
export class EbAuthGuard extends AuthGuard {
  constructor(
    protected authService: AuthService,
    protected authRedirectService: AuthRedirectService,
    protected router: Router,
    protected semanticPathService: SemanticPathService,
    protected ebAuthService: EbAuthService,
    private readonly cookieService: CookieService
  ) {
    super(authService, authRedirectService, router, semanticPathService)
  }

  canActivate(): Observable<boolean | UrlTree> {
    return this.ebAuthService.isUserLoggedIn().pipe(
      map(isLoggedIn => {
        if (!isLoggedIn && !this.accessToken) {
          this.router.navigateByUrl(
            this.isSecuredPage(this.getRedirectUrl()) ? '/' : this.getRedirectUrl()
          )
        }
        return isLoggedIn
      })
    )
  }

  getRedirectUrl(): string {
    return this.router.serializeUrl(this.router.getCurrentNavigation().finalUrl) || ''
  }

  get accessToken() {
    return (
      this.cookieService.get('access_token') ||
      this.cookieService.get('temp_customer_emulation_token')
    )
  }

  isSecuredPage(url: string): boolean {
    let isSecured = false
    securedPagesConfig.forEach(value => {
      if (url.includes(value)) {
        isSecured = true
      }
    })
    return isSecured
  }
}
